<template>
  <table>
    <tbody>
      <tr>
        <translate tag="td"> Was </translate>
        <td class="was">
          <pu-price :price="preDiscountPrice" :display-original-price="true" />
        </td>
      </tr>
      <tr v-for="(offer, index) in offersApplied" :key="index">
        <!-- TODO: needs translation -->
        <td colspan="2" class="offer-color right">
          *{{ offer.name }} ({{ offer.discountPercent }}% off)
        </td>
      </tr>
      <tr v-if="savings">
        <td colspan="2" class="savings right">
          <translate>You save</translate>
          <pu-price :price="savings" :display-original-price="true" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script lang="ts">
import { OfferApplied } from '../../../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import type { SimpleMoney } from '~/utility/money'

@Component
class OffersActive extends Vue {
  @Prop()
  preDiscountPrice: SimpleMoney

  @Prop()
  offersApplied: OfferApplied[]

  @Prop()
  finalPrice: SimpleMoney

  get savings(): SimpleMoney | null {
    if (
      this.preDiscountPrice &&
      this.finalPrice &&
      this.preDiscountPrice.amountMinor &&
      this.finalPrice.amountMinor
    ) {
      const savingsAmount =
        this.preDiscountPrice.amountMinor - this.finalPrice.amountMinor
      if (savingsAmount > 0) {
        return {
          amountMinor: savingsAmount,
          currency: this.preDiscountPrice.currency,
        }
      }
    }
    return null
  }
}

export default toNative(OffersActive)
</script>
